import { useQuery } from '@tanstack/react-query';
import {
  type AdminConfigOut,
  type AdminMarketConfigGetData,
  endpoint,
  http,
  parseApiResponse,
  zAdminMarketConfigGetResponse,
} from '@/shared/api';

/**
 * GET /api/v1/admin/config — параметры рынка для интерфейса админки, без авторизации
 * (docs/decisions.md: эндпоинт добавлен к ТЗ; нужен на экране входа). Схема — из контракта.
 */
export type MarketConfig = AdminConfigOut;

const ENDPOINT = endpoint<AdminMarketConfigGetData>('/api/v1/admin/config');

export async function fetchMarketConfig(): Promise<MarketConfig> {
  const response = await http.get<unknown>(ENDPOINT, { skipAuthRefresh: true });
  return parseApiResponse(zAdminMarketConfigGetResponse, response.data, ENDPOINT);
}

export const marketQueryKeys = {
  config: ['market', 'config'] as const,
};

/** Конфигурация рынка неизменна во время работы бэкенда (ARCH-02) — кэшируется на всю сессию. */
export function useMarketConfig() {
  return useQuery({
    queryKey: marketQueryKeys.config,
    queryFn: fetchMarketConfig,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
  });
}
